export const RESET = 'EXSBWAREHOUSE_UPDATE_RESET'
export const SET_ERROR = 'EXSBWAREHOUSE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBWAREHOUSE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBWAREHOUSE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBWAREHOUSE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBWAREHOUSE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBWAREHOUSE_UPDATE_UPDATE_RETRIEVED'
